module.exports = __webpack_public_path__ + "img/bg5.c3a758d4.png";